/* eslint-disable class-methods-use-this */
import { logger } from '@tecma/logs-fe';

import { ENVIRONMENT } from '../../constants/environment';

class ProjectAPI {
  initRequest: RequestInit;

  constructor() {
    this.initRequest = {
      referrerPolicy: 'unsafe-url',
      headers: {
        'Content-Type': 'application/json',
      }
    };
  }

  async getProjectInfo() {
    try {
      const response = await fetch(`${ENVIRONMENT.REACT_APP_PROJECT_API_BASE_URL}/projects/info`, {
        ...this.initRequest,
        method: 'GET',
        cache: 'no-store',
      });

      if (!response.ok) {
        throw new Error(`Status: ${response.status}`);
      }
      return response;
    } catch (err) {
      logger.error(err);
      throw Error();
    }
  }

  async getProjectInfoById(id: string) {
    try {
      const response = await fetch(`${ENVIRONMENT.REACT_APP_PROJECT_API_BASE_URL}/projects/${id}`, {
        ...this.initRequest,
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`Status: ${response.status}`);
      }
      return response;
    } catch (err) {
      logger.error(err);
      throw Error();
    }
  }

  /** @deprecated */
  async getProjectInfoByHost(hostname: string) {
    try {
      const response = await fetch(`${ENVIRONMENT.REACT_APP_PROJECT_API_BASE_URL}/projects/hostname/${hostname}`, {
        ...this.initRequest,
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error(`Status: ${response.status}`);
      }
      return response;
    } catch (err) {
      logger.error(err);
      throw Error();
    }
  }
}

export default new ProjectAPI();
